(function () {
  'use strict';

  // ── Chef carousel ────────────────────────────────────────────────────────
  function initChefCarousel(sectionEl) {
    var track = sectionEl.querySelector('.ws-chefs__track');
    var prev  = sectionEl.querySelector('.ws-chefs__nav--prev');
    var next  = sectionEl.querySelector('.ws-chefs__nav--next');
    if (!track || !prev || !next) return;

    function cardStep() {
      var card = track.querySelector('.ws-chef');
      var gap  = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 18) || 18;
      return card ? card.offsetWidth + gap : 240;
    }

    function updateNav() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 4);
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  cardStep() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  document.querySelectorAll('.ws-social-proof').forEach(initChefCarousel);

  // Re-init if section injected dynamically (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ws-social-proof')) {
      initChefCarousel(e.target);
    }
  });

  // ── Sticky bar ───────────────────────────────────────────────────────────
  function initStickyBar(sectionEl) {
    var bar = sectionEl.querySelector('.ws-sticky-bar');
    if (!bar) return;

    var stickyAtc = bar.querySelector('.ws-sticky-bar__atc');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        var mainAtc = document.querySelector('.product-form__submit');
        if (mainAtc) mainAtc.click();
      });
    }

    // Watch the main-product buy buttons and the final CTA section
    var heroBuy  = document.querySelector('product-form') ||
                   document.querySelector('.ws-buy-card') ||
                   document.querySelector('.shopify-section--main-product');
    var finalCta = document.querySelector('.ws-final-cta');

    if (!heroBuy || !('IntersectionObserver' in window)) {
      // Fallback: always show after 300px scroll
      window.addEventListener('scroll', function () {
        bar.classList.toggle('ws-sticky-bar--show', window.scrollY > 300);
      }, { passive: true });
      return;
    }

    var heroVisible  = true;
    var finalVisible = false;

    function update() {
      bar.classList.toggle('ws-sticky-bar--show', !heroVisible && !finalVisible);
    }

    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(heroBuy);

    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(finalCta);
    }
  }

  document.querySelectorAll('.ws-sticky-buy').forEach(initStickyBar);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ws-sticky-buy')) {
      initStickyBar(e.target);
    }
  });

  // ── What's Included tap-to-zoom ──────────────────────────────────────────
  var _wsZoomModal = null;

  function getOrCreateZoomModal() {
    if (_wsZoomModal) return _wsZoomModal;
    var m = document.createElement('div');
    m.className = 'ws-img-zoom';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Image zoom');
    m.innerHTML =
      '<button class="ws-img-zoom__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24">' +
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
      '<img class="ws-img-zoom__img" src="" alt="">';
    document.body.appendChild(m);

    var closeBtn = m.querySelector('.ws-img-zoom__close');
    var img = m.querySelector('.ws-img-zoom__img');

    function closeModal() {
      m.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    closeBtn.addEventListener('click', closeModal);
    m.addEventListener('click', function (e) { if (e.target === m) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.classList.contains('is-open')) closeModal();
    });

    _wsZoomModal = {
      open: function (src, alt) {
        img.src = src;
        img.alt = alt || '';
        m.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }
    };
    return _wsZoomModal;
  }

  function initInclZoom() {
    document.querySelectorAll('.ws-incl__img').forEach(function (img) {
      if (img._wsZoomBound || img.tagName !== 'IMG') return;
      img._wsZoomBound = true;

      function open() {
        // Derive a 1400px version from the existing src (Shopify CDN width param)
        var large = img.src.replace(/[?&]width=\d+/, function (m) {
          return m[0] + 'width=1400';
        });
        getOrCreateZoomModal().open(large, img.alt);
      }

      img.addEventListener('click', open);
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  }

  initInclZoom();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ws-whats-included')) initInclZoom();
  });

  // ── Final CTA buy button ──────────────────────────────────────────────────
  function initFinalCtaBtn() {
    var btn = document.querySelector('.ws-final-cta__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var mainAtc = document.querySelector('.product-form__submit');
      if (mainAtc) mainAtc.click();
    });
  }

  initFinalCtaBtn();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ws-final-cta')) initFinalCtaBtn();
  });

})();
